import React from 'react'
import "./style.css";

const Header = ({children}) => {
  return (
    <header className="site-header">
        {children}
    </header>
  )
}

export default Header;